module.exports = __webpack_public_path__ + "img/UTKODA-17.e37b9a74.jpg";